import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_MEMBERS_DETAILS,
  CREATE_MEMBERS,
  UPDATE_MEMBERS,
  DELETE_USERS,
  DELETE_MEMBERS,
  GET_USERS,
  CREATE_USERS,
  UPDATE_USERS,
  GET_USERS_WITH_CROSS_BRANCH,
} from "./actionTypes"
import {
  getMemberDetailsSuccess,
  getMemberDetailsFail,
  createMemberFail,
  createMemberSuccess,
  updateMemberSuccess,
  updateMemberFail,
  deleteMemberSuccess,
  deleteMemberFail,
  getUsersSuccess,
  getUsersFail,
  createUsersSuccess,
  createUsersFail,
  updateUsersSuccess,
  updateUsersFail,
  deleteUsersSuccess,
  deleteUsersFail,
  getUsersWithCrossBranchSuccess,
  getUsersWithCrossBranchFail,
} from "./actions"

import { get, post, ApiPut, del } from "helpers/api_helper"
import { Notification } from "../../components/Common/Notification"

const branchId = sessionStorage.getItem("branchId") || ""

// Helper to check if branch is a valid value
const isValidBranch = (branch) => branch && branch !== "undefined" && branch !== "null" && branch !== ""

// Users - This line cannot be edited or removed
function getMembersAPi({ page, limit, searchText, handleRoles, sort }) {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/member/admin/all/?page=${page && page}&limit=${limit ? limit : ""
    }&search=${searchText ? searchText : ""}&sort=${handleRoles ? handleRoles : sort
    }${branchQuery}`
  )

}

const getMemberDetailsAPi = usersId => {
  return get(`/member/admin/single/${usersId}`)
}

const createMemberApi = ({ users }) => {
  return post("/member/admin/new", users)
}

const updateMemberApi = ({ users, usersId }) => {
  return ApiPut(`/user/admin/${usersId}`, users)
}

const deleteMemberApi = ({ usersId }) => {
  return del(`/member/admin/${usersId}`)
}

function getUsersAPi({
  page,
  limit,
  searchText,
  handleRoles,
  sort,
  branchId,
  staffType,
}) {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/user/admin/all/?page=${page && page}&limit=${limit ? limit : ""}&search=${searchText ? searchText : ""
    }&sort=${handleRoles ? handleRoles : sort}${branchQuery}&staffType=${staffType || ""}`
  )
}

// Get users with cross-branch enquiry managers (Admin only)
function getUsersWithCrossBranchAPi({
  page,
  limit,
  searchText,
  handleRoles,
  sort,
  branchId,
  staffType,
}) {
  const branchQuery = isValidBranch(branchId) ? `&branch=${branchId}` : ""

  return get(
    `/user/admin/all-with-cross-branch-enquiry-managers?page=${page && page}&limit=${limit ? limit : ""}&search=${searchText ? searchText : ""
    }&sort=${handleRoles ? handleRoles : sort}${branchQuery}&staffType=${staffType || ""}`
  )
}

const createUsersApi = ({ users }) => {
  return post("/user/new", users)
}

const updateUserApi = ({ users, usersId }) => {
  return ApiPut(`/user/${usersId}`, users)
}

const deleteUserApi = ({ userId }) => {
  return del(`/user/${userId}`)
}

function* fetchUsersDetails({ payload: usersId }) {
  try {
    const response = yield call(getMemberDetailsAPi, usersId)
    yield put(getMemberDetailsSuccess(response))
  } catch (error) {
    yield put(getMemberDetailsFail(error))
  }
}

function* onCreateMembers({ payload }) {
  try {
    const response = yield call(createMemberApi, payload)
    yield put(createMemberSuccess(response))
    if (payload.onCloseClick) {
      payload.onCloseClick()
    }

    const mailStatus = response?.setPasswordData
    if (mailStatus?.emailSent === false) {
      Notification({
        type: "warning",
        message:
          mailStatus?.message ||
          "Member created, but set password email was not sent.",
        title: "",
      })
    } else {
      Notification({
        type: "success",
        message:
          mailStatus?.message ||
          "Member Created Successfully!",
        title: "",
      })
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createMemberFail(error))
  }
}

function* onUpdateMembers({ payload }) {
  try {
    const response = yield call(updateMemberApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Member Updated Successfully!",
        title: "",
      })
      yield put(updateMemberSuccess(response))
      if (payload.onCloseClick) {
        payload.onCloseClick()
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateMemberFail(error.response.data))
  }
}

function* onDeleteMembers({ payload }) {
  try {
    const response = yield call(deleteMemberApi, payload)
    yield put(deleteMemberSuccess(response))
    Notification({
      type: "success",
      message: "Users Deleted Successfully!",
      title: "",
    })
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteMemberFail(error?.response?.data))
  }
}

// users

function* fetchUsers({ payload }) {
  try {
    const response = yield call(getUsersAPi, payload)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onCreateUsers({ payload }) {
  try {
    const response = yield call(createUsersApi, payload)
    yield put(createUsersSuccess(response))
    payload?.onCloseClick()
    Notification({
      type: "success",
      message: "Users Created Successfully!",
      title: "",
    })
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(createUsersFail(error))
  }
}

function* onUpdateUsers({ payload }) {
  try {
    const response = yield call(updateUserApi, payload)
    if (response) {
      Notification({
        type: "success",
        message: "Users Updated Successfully!",
        title: "",
      })
      yield put(updateUsersSuccess(response))
      if (payload.history) {
        payload.history.push("/userss")
      }
    }
  } catch (error) {
    if (error.response?.data?.message) {
      Notification({
        type: "error",
        message: error.response?.data?.message,
        title: "",
      })
    }
    if (error?.response?.status === 413) {
      Notification({
        type: "error",
        message: "file size is Too Large",
        title: "",
      })
    }
    yield put(updateUsersFail(error.response.data))
  }
}

function* onDeleteUsers({ payload }) {
  try {
    const response = yield call(deleteUserApi, payload)
    yield put(deleteUsersSuccess(response))
    Notification({
      type: "success",
      message: "Users Deleted Successfully!",
      title: "",
    })
  } catch (error) {
    if (error?.response?.data?.message) {
      Notification({
        type: "error",
        message: error?.response?.data?.message,
        title: "",
      })
    }
    yield put(deleteUsersFail(error?.response?.data))
  }
}

// Get users with cross-branch enquiry managers (Admin only)
function* fetchUsersWithCrossBranch({ payload }) {
  try {
    const response = yield call(getUsersWithCrossBranchAPi, payload)
    yield put(getUsersWithCrossBranchSuccess(response))
  } catch (error) {
    yield put(getUsersWithCrossBranchFail(error))
  }
}

function* usersSaga() {
  yield takeEvery(GET_MEMBERS_DETAILS, fetchUsersDetails)
  yield takeEvery(CREATE_MEMBERS, onCreateMembers)
  yield takeEvery(UPDATE_MEMBERS, onUpdateMembers)
  yield takeEvery(DELETE_MEMBERS, onDeleteMembers)

  // users
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(CREATE_USERS, onCreateUsers)
  yield takeEvery(UPDATE_USERS, onUpdateUsers)
  yield takeEvery(DELETE_USERS, onDeleteUsers)
  yield takeEvery(GET_USERS_WITH_CROSS_BRANCH, fetchUsersWithCrossBranch)
}
export default usersSaga
